import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../contexts/LanguageContext";
import api from "../../lib/api";
import { ArrowRight } from "lucide-react";

export default function Applications() {
  const { t, lang } = useI18n();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/applications/me").then((r) => setApps(r.data)).finally(() => setLoading(false));
  }, []);

  const statusColor = {
    submitted: "bg-blue-50 text-blue-700",
    review: "bg-yellow-50 text-yellow-700",
    interview: "bg-purple-50 text-purple-700",
    offer: "bg-green-50 text-green-700",
    rejected: "bg-red-50 text-red-700",
  };

  return (
    <div className="container-pad mx-auto max-w-[1200px] py-12" data-testid="page-applications">
      <h1 className="text-3xl font-extrabold text-navy">{t.dash.apps}</h1>
      {loading ? (
        <div className="py-20 text-center text-slate-500">{t.common.loading}</div>
      ) : apps.length === 0 ? (
        <div className="py-20 text-center text-slate-500" data-testid="apps-empty">{t.dash.noApps}</div>
      ) : (
        <div className="space-y-3 mt-6">
          {apps.map((a) => (
            <div key={a.application_id} className="bg-white border border-slate-100 rounded-[24px] p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3" data-testid={`app-row-${a.application_id}`}>
              <div>
                <div className="text-xs uppercase tracking-widest text-slate-500">{a.job?.category} · {a.job?.type}</div>
                <div className="font-bold text-navy text-lg mt-1">{a.job?.title?.[lang] || a.job?.title?.en || "—"}</div>
                <div className="text-sm text-slate-600">{a.job?.company} · {a.job?.location}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-bold ${statusColor[a.status] || "bg-soft text-slate-600"}`}>
                  {t.dash.status[a.status] || a.status}
                </span>
                {a.job?.job_id && (
                  <Link to={`/job/${a.job.job_id}`} className="inline-flex items-center gap-1 text-navy font-semibold hover:text-brandred">{t.jobs.details} <ArrowRight size={14} /></Link>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
